import { useState } from "react";

export function useSortTable(data) {
  const [sortField, setSortField] = useState("");
  const [order, setOrder] = useState("asc");
  const [tableData, setTableData] = useState(data);

  const sortingHandler = (field) => {
    if (field === sortField) {
      setOrder(order === "asc" ? "desc" : "asc");
    } else {
      setSortField(field);
      setOrder((prevOrder) => (prevOrder === "asc" ? "desc" : "asc"));
    }

    if (field) {
      const sorted = [...data].sort((a, b) => {
        if (a[field] === null) return 1;
        if (b[field] === null) return -1;
        if (a[field] === null && b[field] === null) return 0;
        return (
          a[field]?.toString().localeCompare(b[field]?.toString(), "en", {
            numeric: true,
          }) * (order === "asc" ? 1 : -1)
        );
      });
      setTableData(sorted);
    }
  };
  return [tableData, sortingHandler];
}
